
import React from "react";

import Header from "./Header/header";
import Main from "./Main/main"



function Factories() {
    return (
        <div>

            <Header />
            <Main />
        </div>
    );
}

export default Factories;
